// @mui
import { styled, alpha } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import ListSubheader from '@mui/material/ListSubheader';
import ListItemButton from '@mui/material/ListItemButton';
//
import { HEADER } from '../../../config-layout';
import { NavItemDesktopProps } from '../types';

// ----------------------------------------------------------------------

type ListItemProps = Omit<NavItemDesktopProps, 'item'>;

export const ListItem = styled(ListItemButton, {
  shouldForwardProp: (prop) =>
    prop !== 'active' && prop !== 'open' && prop !== 'offsetTop' && prop !== 'subItem',
})<ListItemProps>(({ active, open, offsetTop, subItem, theme }) => {
  return {
    ...theme.typography.body2,
    padding: '8px 16px',
    height: 'auto',
    borderRadius: '6px',
    color: theme.palette.text.secondary,
    fontWeight: 500,
    transition: 'all 0.2s ease',
    '&:hover': {
      color: theme.palette.text.primary,
      backgroundColor: alpha(theme.palette.text.primary, 0.05),
    },
    // Sub item
    ...(subItem && {
      ...theme.typography.body2,
      color: theme.palette.text.secondary,
      '&:hover': {
        color: theme.palette.text.primary,
        backgroundColor: alpha(theme.palette.text.primary, 0.05),
      },
    }),
    // Active
    ...(active && {
      color: theme.palette.text.primary,
      backgroundColor: alpha(theme.palette.text.primary, 0.08),
    }),
    // Active sub item
    ...(active &&
      subItem && {
        color: theme.palette.text.primary,
        backgroundColor: alpha(theme.palette.text.primary, 0.08),
      }),
    // Open
    ...(open && {
      color: theme.palette.text.primary,
      backgroundColor: alpha(theme.palette.text.primary, 0.05),
    }),
  };
});

// ----------------------------------------------------------------------

export const StyledMenu = styled(Paper)(({ theme }) => ({
  left: 0,
  right: 0,
  margin: 'auto',
  position: 'fixed',
  zIndex: theme.zIndex.modal,
  padding: theme.spacing(4, 3, 3, 3),
  maxWidth: theme.breakpoints.values.lg,
  top: HEADER.H_DESKTOP_OFFSET,
  background: alpha(theme.palette.background.default, 0.95),
  backdropFilter: 'blur(20px)',
  border: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
  borderRadius: '12px',
  boxShadow: theme.customShadows.dropdown,
}));

// ----------------------------------------------------------------------

export const StyledSubheader = styled(ListSubheader)(({ theme }) => ({
  ...theme.typography.overline,
  padding: 0,
  fontSize: 11,
  letterSpacing: '0.1em',
  color: theme.palette.text.primary,
  backgroundColor: 'transparent',
}));
